<template>
  <div>
    <el-cascader
      v-if="type === 'tree' && showCascader"
      :clearable="clearable"
      :size="size"
      :key="cascaderKey"
      v-model="val"
      :disabled="disabled"
      :placeholder="placeholder"
      :options="filterList"
      :props="props"
      @change="onChange"
      :filterable="filterable"
      :style="{ width: width, verticalAlign: 'top' }"
      :show-all-levels="showAllLevels"
      class="custom-select"
      ref="tree"
    ></el-cascader>
    <el-select
      v-if="type === 'select'"
      :allow-create="allowCreate"
      :default-first-option="defaultFirstOption"
      :clearable="clearable"
      :size="size"
      :filterable="filterable"
      v-model="val"
      :disabled="disabled"
      :placeholder="placeholder"
      @change="onChange"
      @clear="onClear"
      :style="{ width: width, verticalAlign: 'top', boder: noBoder ? 'none' : '' }"
      :multiple="multiple"
      :multipleLimit="multipleLimit"
      :reserve-keyword="reserveKeyword"
      :remote="remote"
      :remote-method="remoteMethod"
      :collapse-tags="collapseTags"
      class="custom-select"
      :class="{ 'theme-yellow': theme === 'yellow', radius: radius }"
    >
      <slot name="option"></slot>
      <el-option v-for="(item, index) in filterList" :key="index" :label="item[props.label]" :value="`${item[props.value]}`" :disabled="item.disabled" />
    </el-select>
  </div>
</template>

<script>
import apis from '@/utils/apis';



export default {
  props: {
    model: [Object, Array],
    collapseTags: { type: Boolean, default: false },
    data: [Array], // 下拉数据
    type: { type: String, default: 'select' },
    width: { type: String },
    value: [String, Array, Number],
    placeholder: { type: String },
    cascaderKey: { type: String },
    size: { type: String },
    clearable: { type: Boolean, default: true },
    disabled: { type: Boolean, default: false },
    filterable: { type: Boolean, default: false },
    allowCreate: { type: Boolean, default: false },
    defaultFirstOption: { type: Boolean, default: false },
    listener: [String, Number], // 监听变更初始化下拉列表
    isDefault: {
      type: Boolean, // 默认选中第一项
      default: false
    },
    auto: {
      type: Boolean, // 自动加载
      default: true
    },
    code: {
      type: String, // 字典编码
      default: ''
    },
    url: {
      type: String, // 请求地址
      default: ''
    },
    method: {
      type: String, // 请求地址
      default: 'GET'
    },
    params: {
      type: Object, // 请求参数
      default() {
        return {};
      }
    },
    props: {
      type: Object, // 选项配置
      default() {
        return { label: 'name', value: 'value' };
      }
    },
    multiple: {
      type: Boolean, // 是否多选
      default: false
    },
    multipleLimit: {
      type: Number // 多选项数量限制
    },
    valueType: {
      type: String // 绑定的value类型
    },
    dataFilter: {
      type: Function // 列表过滤方法
    },
    filterOptions: [Object, Number, String, Array],
    showAllLevels: {
      type: Boolean,
      default: true
    },
    // 完整请求地址
    fullUrl: {
      type: String,
      default: ''
    },
    noBoder: {
      type: Boolean,
      default: false
    },
    remote: {
      type: Boolean,
      default: false
    },
    reserveKeyword: {
      type: Boolean,
      default: false
    },
    // 主题：用于控制组件的颜色主题,
    // 可选：yellow
    theme: {
      type: String,
      default: ''
    },
    // 是否圆角
    radius: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      val: '',
      list: [],
      loadingCode: false,
      showCascader: true
    };
  },
  computed: {
    filterList: vm => (vm.dataFilter ? vm.dataFilter(vm.list, vm.filterOptions) : vm.list)
  },
  watch: {
    data() {
      this.list = this.data;
    },
    value() {
      this.initData();
    },
    code() {
      this.list = [];
      this.$emit('input', '');
      this.getSelectList();
    },
    url() {
      this.list = [];
      this.$emit('input', '');
      this.getSelectList();
    },
    listener() {
      this.list = [];
      this.$emit('input', '');
      if (!`${this.listener}`.includes('null')) {
        this.getSelectList();
      }
    },

  },
  mounted() {
    this.list = this.data || [];
    this.initData();
    if (this.auto) {
      this.getSelectList();
    }
  },
  methods: {
    // 控制custom-select的val，避免外部传入数值0且在list中匹配不到时，custom-select的“0”值显示
    initVal() {
      if (this.type === 'select') {
        if (this.list && this.list.length && !Array.isArray(this.value) && (this.value === 0 || this.value === '0')) {
          // this.val是否在this.list中找到
          const valInList = this.list.some(item => `${item[this.props.value]}` === `${this.val}`);
          // 如果this.val在this.list中匹配不到，则将el-select的value置空，保留外层的value
          if (!valInList) {
            this.val = '';
          }
        }
      }
    },
    initData: function () {
      if (typeof this.value === 'number') {
        this.val = `${this.value}`;
        this.$emit('input', this.val);
        this.initVal();
        return;
      }
      if (Array.isArray(this.value)) {
        this.val = this.value.map(t => `${t}`);
        return;
      }
      this.val = this.value;
      this.initVal();
    },
    // 获取字典
    getSelectList: function () {
      if (this.code) {
        this.getDictionary(this.code, (dictionary) => {
          this.list = dictionary[this.code];
          // this.list = this.dataFilter ? this.dataFilter(list, this.filterOptions) : list;
          this.$emit('getList', this.list);
          if (this.isDefault && this.list.length && !this.value) {
            this.$emit('input', this.list[0][this.props.value]);
            this.$emit('init', this.list[0][this.props.value]);
          }
          this.initVal();
        });
        return;
      }
      if (this.url || this.fullUrl) {
        // GET
        if (this.method === 'GET') {
          this.$getJSON(this.fullUrl || apis[this.url], this.params).then((res) => {
            this.list = res.data || [];
            // this.list = this.dataFilter ? this.dataFilter(list, this.filterOptions) : list;
            this.$emit('getList', this.list);
            if (this.isDefault && this.list.length && !this.value) {
              this.$emit('input', this.list[0][this.props.value]);
              this.$emit('init', this.list[0][this.props.value]);
            }
            this.initVal();
          });
          return;
        } else {
          // POST
          this.$postJSON(this.fullUrl || apis[this.url], this.params).then((res) => {
            this.list = res.data || [];
            // this.list = this.dataFilter ? this.dataFilter(list, this.filterOptions) : list;
            this.$emit('getList', this.list);
            if (this.isDefault && this.list.length && !this.value) {
              this.$emit('input', this.list[0][this.props.value]);
              this.$emit('init', this.list[0][this.props.value]);
            }
            this.initVal();
          });
        }
      }
      this.list = [];
    },
    // 获取选中节点列表
    getCheckedNodes() {
      const nodes = this.$refs.tree.getCheckedNodes();
      if (!nodes.length) {
        return nodes;
      }
      const pathNodes = nodes[0].pathNodes;
      return pathNodes.map(item => item.data);
    },
    // 获取选中节点的label列表
    getCheckedLabel() {
      const nodes = this.$refs.tree.getCheckedNodes(); // 获取选中的节点
      if (!nodes.length) {
        return nodes;
      }
      const label = nodes.map(node => node.label); // 提取 label
      return label[0];
    },
    // 远程加载消息名称下拉项
    remoteMethod: function (query) {
      this.loadingCode = true;
      this.$getJSON(apis[this.url]).then((res) => {
        this.loadingCode = false;
        const list = res.data;
        this.list = query ? list.filter(item => item[this.props.label].toLowerCase().indexOf(query.toLowerCase()) > -1) : list;
      });
    },
    // 选中值
    onChange: function () {
      this.$emit('input', this.val);
      if (this.type === 'tree') {
        this.$nextTick(() => {
          if (this.props.checkStrictly && !this.props.multiple) {
            this.$refs.tree.dropDownVisible = false;
          }
        });
        this.$emit('treeValChangeLabel', this.getCheckedLabel());
        this.$emit('treeValChange', this.getCheckedNodes());
        return;
      }
      if (Array.isArray(this.val)) {
        const item = this.val.map(t => this.list.find(f => `${f[this.props.value]}` === t));
        const map = this.props.map;
        if (this.model && map) {
          Object.keys(map).forEach((key) => {
            if (item.length) {
              this.model[map[key]] = item.map(t => t[key]);
            } else {
              this.model[map[key]] = [];
            }
          });
        }
        this.$emit('change', item);
        return;
      }
      const item = this.filterList.find(t => `${t[this.props.value]}` === `${this.val}`);
      const map = this.props.map;
      if (this.model && map) {
        Object.keys(map).forEach((key) => {
          if (item) {
            this.model[map[key]] = item[key];
          } else {
            this.model[map[key]] = '';
          }
        });
      }
      this.$emit('change', item);
    },
    onClear: function () {
      this.$emit('clear');
    },
    // 获取下拉框选中的item
    getSelectedNode() {
      const valueKey = this.props.value;
      const item = this.list.find(obj => `${obj[valueKey]}` === `${this.val}`);
      return item;
    },
  }
};
</script>
<style lang="scss">
.custom-select {
  width: 100%;
  &.theme-yellow {
    .el-input {
      .el-input__suffix {
        .el-icon-arrow-up:before {
          color: #ffad00;
        }
      }
    }
  }
}
</style>
